import { Stack, Typography } from '@mui/material'
import { FileList } from '../../../v2/components/fileList'
interface IFilesFieldCard {
    id?: string
    description: string
    files?: string[]
}
export const FilesFieldCard = ({ id, description, files }: IFilesFieldCard) => {
    if (!files) return null
    return (
        <Stack>
            <Typography variant={'bodySubtextBold'}>{description}</Typography>
            <FileList
                id={id}
                data={{ files: files }}
                renderOptions={{ value: 'files' }}
            />
        </Stack>
    )
}
